module.exports = __webpack_public_path__ + "c0ebf3a27e690d270fbaece1f6ac112a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-30.png
// module id = 1612
// module chunks = 0